import { Link } from 'react-router-dom';
import { rankingList } from '@/mocks/ranking';
import { formatHeat } from '@/utils/format';

const hotKeywords = [
  '直播口误',
  '接梗天花板',
  '表情包复读',
  '弹幕刷屏',
  '群聊破防',
  '评论区连载',
  '社死名场面',
  '二创出圈',
];

export default function RankingAside() {
  const freshList = rankingList.filter((item) => item.trend === 'up').slice(0, 4);

  return (
    <aside className="flex flex-col gap-5">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="flex items-center gap-2 text-base text-foreground-950">
          <i className="ri-rocket-2-line text-primary-500" aria-hidden="true" />
          本周新上榜
        </h3>
        <ul className="mt-4 space-y-3">
          {freshList.map((item) => (
            <li key={item.id}>
              <Link
                to={`/scene/${item.id}`}
                className="group flex items-start gap-3 text-sm text-foreground-800 transition-colors hover:text-primary-600"
              >
                <i className="ri-arrow-right-up-line mt-0.5 text-primary-500" aria-hidden="true" />
                <span className="min-w-0 flex-1">
                  <span className="line-clamp-2">{item.title}</span>
                  <span className="mt-1 block text-xs text-foreground-500">
                    周热度 {formatHeat(item.week)}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h3 className="flex items-center gap-2 text-base text-foreground-950">
          <i className="ri-price-tag-3-line text-accent-600" aria-hidden="true" />
          梗词速览
        </h3>
        <p className="mt-2 text-xs text-foreground-500">点击关键词，直接跳到对应分类找现场。</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {hotKeywords.map((keyword) => (
            <Link
              key={keyword}
              to={`/topics?q=${encodeURIComponent(keyword)}`}
              className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              #{keyword}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg bg-secondary-950 p-5 text-background-100">
        <h3 className="flex items-center gap-2 text-base text-background-50">
          <i className="ri-information-line text-accent-300" aria-hidden="true" />
          榜单说明
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-background-200">
          热力值根据站内浏览、评论与转发情况综合计算，用于帮你判断先后顺序，不代表任何官方统计。
        </p>
      </div>
    </aside>
  );
}